import "@/App.css";
import { useEffect } from "react";
import { GAMES } from "@/lib/games";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import GamePage from "@/pages/GameRoom";
import Wallet from "@/pages/Wallet";
import Admin from "@/pages/AdminPanel";
import Support from "@/pages/Support";

const Guard = ({ children, admin }) => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-[60vh] flex items-center justify-center text-zinc-500">Yüklənir...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};

const TITLES = { "/login": "Giriş", "/register": "Qeydiyyat", "/wallet": "Kassa", "/support": "Dəstək", "/forgot-password": "Şifrəni bərpa et" };
const ScrollTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    const g = pathname.startsWith("/game/") && GAMES.find((x) => x.id === pathname.slice(6));
    const t = g ? `${g.name} oyna` : TITLES[pathname];
    document.title = t ? `${t} | JACKPOT AZ — Onlayn Kazino` : "JACKPOT AZ — Azərbaycanın Onlayn Kazinosu | Aviator, Slotlar, Rulet";
  }, [pathname]);
  useEffect(() => {
    if (hash) document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <div className="App grain min-h-screen bg-[#050505]">
      <AuthProvider>
        <BrowserRouter>
          <ScrollTop />
          <Header />
          <main className="pt-20">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/game/:id" element={<GamePage />} />
              <Route path="/wallet" element={<Guard><Wallet /></Guard>} />
              <Route path="/support" element={<Guard><Support /></Guard>} />
              <Route path="/admin" element={<Guard admin><Admin /></Guard>} />
            </Routes>
          </main>
          <Footer />
          <Toaster theme="dark" position="top-center" offset={90} richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
